import { render, staticRenderFns } from "./AuthNotes.vue?vue&type=template&id=094f3795&"
import script from "./AuthNotes.vue?vue&type=script&lang=js&"
export * from "./AuthNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports